module.exports = __webpack_public_path__ + "img/logo.b989e1c7.png";